module.exports = __webpack_public_path__ + "static/media/gray-arrow-left.6d0f9c96.svg";